import inherited from 'mastodon/locales/hr.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
